import React from 'react';
import { Input, Select, Button, SelectItem } from '@heroui/react'; // Import HeroUI components
import THEME from '../theme/constants';
import { parseExamDate, isSameDay } from '../utils/dateUtils';

const SearchSection = ({ 
  building, 
  setBuilding, 
  room, 
  setRoom, 
  checkAvailability, 
  isSearching,
  selectedDate,
  setSelectedDate,
  availableDates,
  termLabel
}) => {
  return (
    <section className="mt-4 mb-8">
      {termLabel && (
        <div className="text-center mb-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary ring-1 ring-primary/20 text-sm font-semibold dark:bg-primary dark:text-white dark:ring-0">
            {termLabel}
          </span>
        </div>
      )}
      
      <div className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800">
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-gray-100">Check Room Availability</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <Input
              variant='bordered'
              classNames={THEME.components.input.classNames}
              id="building"
              label="Building Number"
              placeholder="e.g. 24"
              value={building}
              onChange={(e) => setBuilding(e.target.value)}
              fullWidth
            />
          </div>
          
          <div>
            <Input
              variant='bordered'
              classNames={THEME.components.input.classNames}
              id="room"
              label="Room Number"
              placeholder="e.g. 120"
              value={room}
              onChange={(e) => setRoom(e.target.value)}
              fullWidth
            />
          </div>
          
          <div>
            <Select
              variant='bordered'
              classNames={{
                // Apply all the select styles, not just the trigger
                trigger: THEME.components.select.classNames.trigger,
                base: THEME.components.select.classNames.base,
                value: THEME.components.select.classNames.value,
                listbox: THEME.components.select.classNames.listbox,
                popoverContent: THEME.components.select.classNames.popoverContent
              }}
              id="dateSelect"
              label="Date"
              placeholder="Select date"
              selectedKeys={selectedDate ? [selectedDate] : []}
              onSelectionChange={(keys) => {
                const selected = keys.size > 0 ? Array.from(keys)[0] : "";
                setSelectedDate(selected);
              }}
              fullWidth
            >
              {(() => {
                const today = new Date();
                const isTodayInFinals = availableDates?.some(d => {
                  const parsed = parseExamDate(d);
                  return parsed ? isSameDay(parsed, today) : false;
                });
                return (
                  <>
                    {isTodayInFinals && (
                      <SelectItem key="" value="">Today</SelectItem>
                    )}
                    {availableDates
                      .filter(date => {
                        if (!isTodayInFinals) return true;
                        const parsed = parseExamDate(date);
                        return parsed ? !isSameDay(parsed, today) : true;
                      })
                      .map(date => (
                        <SelectItem key={date} value={date}>
                          {date}
                        </SelectItem>
                      ))}
                  </>
                );
              })()}
            </Select>
          </div>
        </div>
        
        <Button
          onPress={checkAvailability}
          disabled={isSearching || !building || !room}
          variant="filled"
          isLoading={isSearching}
          disableRipple={isSearching || !building || !room} // Prevent ripple effect when disabled
          disableAnimation={isSearching || !building || !room} // Prevent animations when disabled
          className={`bg-primary text-white ${
            // Only apply hover effect when not disabled
            (!isSearching && building && room) ? "hover:bg-primary-hover" : ""
          }`}
          style={{
            // Maintain primary color even when disabled
            opacity: (isSearching || !building || !room) ? 0.7 : 1,
            cursor: (isSearching || !building || !room) ? "not-allowed" : "pointer",
            // Prevent the button from shrinking when pressed while disabled
            transform: "none",
            transition: "opacity 0.2s ease"
          }}
          fullWidth
        >
          {isSearching ? 'Checking...' : 'Check Availability'}
        </Button>
      </div>
    </section>
  );
};

export default SearchSection;